import { ApiEmployment } from '../api/api-types/employment.api';

export const employmentMocks: ApiEmployment[] = [
	{
		id: 1,
		maximumOverAllPositionShare: 4,
		remark: 'Full-time position',
		serviceId: 1,
	},
	{
		id: 2,
		maximumOverAllPositionShare: 3,
		remark: 'Part-time position',
		serviceId: 2,
	},
];
